import React, { useState } from 'react';

import closeOut from '../../assets/splashPages/gara/closeOut.png';
import andembryLogo from '../../assets/splashPages/gara/andembryLogo.png';
import plus from '../../assets/splashPages/gara/plus.png';
import chevron from '../../assets/splashPages/gara/chevron.png';

const GaraSplashPage = ({ toggleModal }) => {
  const [isiCollapsed, setIsiCollapsed] = useState(true);

  const toggleIsi = () => {
    setIsiCollapsed(!isiCollapsed);
  };

  const renderIsiTop = () => {
    return (
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: -8,
            right: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={toggleIsi}
        >
          <img src={isiCollapsed ? plus : chevron} alt="Toggle" style={{ width: 20 }} />
        </div>
        <div style={{ fontSize: 20 }}>
          <p style={{ fontWeight: 'bold', color: '#003C71' }}>IMPORTANT SAFETY INFORMATION</p>
          <p>
            ANDEMBRY® (garadacimab-gxii) injection, for subcutaneous use, is an activated Factor XII
            (FXIIa) inhibitor (monoclonal antibody) indicated for prophylaxis to prevent attacks of
            hereditary angioedema (HAE) in adult and pediatric patients aged 12 years and older.
          </p>
        </div>
      </div>
    );
  };

  const renderIsiContent = () => {
    return (
      <div style={{ marginTop: 20, fontSize: 20 }}>
        <p>
          The most common adverse reactions in the pivotal trial (incidence{' '}
          <span style={{ fontSize: '1.1rem', position: 'relative', bottom: 2 }}>&ge;</span>7%) were
          nasopharyngitis and abdominal pain. In the pivotal trial and the open-label extension
          study, injection-site reactions (eg, injection-site bruising, injection-site erythema,
          injection-site hematoma, injection-site pruritus, injection-site urticaria) were reported
          in 23 (14%) patients.
        </p>
        <p>
          No dedicated drug interaction studies have been conducted, nor is there data concerning
          the use of ANDEMBRY in women who are pregnant or breastfeeding. The safety and efficacy of
          ANDEMBRY in patients under 12 years of age have not been established.
        </p>
        <p>
          <u>Drug Interference with Laboratory Test:</u> ANDEMBRY can prolong activated partial
          thromboplastin time (aPTT) due to an interaction of garadacimab-gxii with the aPTT assay.
        </p>
        <p style={{ fontWeight: 500 }}>
          Please see full{' '}
          <a
            style={{ color: '#003C71' }}
            href="https://labeling.cslbehring.com/PI/US/Andembry/EN/Andembry-Prescribing-Information.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            prescribing information
          </a>{' '}
          for ANDEMBRY.
        </p>
        <p>
          To report SUSPECTED ADVERSE REACTIONS, contact the CSL Behring Pharmacovigilance
          Department at{' '}
          <a style={{ color: '#003C71', whiteSpace: 'nowrap' }} href="tel:1-866-915-6958">
            1-866-915-6958
          </a>{' '}
          or FDA at{' '}
          <a style={{ color: '#003C71', whiteSpace: 'nowrap' }} href="tel:1-800-FDA-1088">
            1-800-FDA-1088
          </a>{' '}
          or{' '}
          <a
            style={{ color: '#003C71' }}
            href="https://www.fda.gov/medwatch"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.fda.gov/medwatch
          </a>
          .
        </p>
      </div>
    );
  };

  const renderMainContent = () => {
    return (
      <div
        style={{
          fontSize: 20,
          color: '#003C71',
          borderBottom: '3px solid #FFC94E',
          padding: '20px 0'
        }}
      >
        Thank you for your interest in the upcoming CSL Behring educational program. The program was
        initially planned to be “Navigating the HAE Patient Journey” and has transitioned to a
        branded program, “ANDEMBRY® (garadacimab-gxii): Navigating the HAE Patient Journey.”
        <br />
        <br />
        This change is a result of the recent FDA approval of ANDEMBRY. We believe this change will
        provide educational insights regarding ANDEMBRY, and we sincerely hope you&apos;ll join us.
        <br />
        <br />
        Please proceed if you would like to register for the program, “ANDEMBRY® (garadacimab-gxii):
        Navigating the HAE Patient Journey.”
        <br />
        <br />
        Kind regards,
        <br />
        The ANDEMBRY Team
      </div>
    );
  };

  const renderIsi = () => {
    return (
      <div>
        {renderIsiTop()}
        {!isiCollapsed && renderIsiContent()}
      </div>
    );
  };

  return (
    <div style={{ fontFamily: 'Barlow Condensed' }}>
      <div style={{ padding: '10px 30px' }}>
        <div style={{ borderBottom: '3px solid #FFC94E', paddingBottom: 10, marginBottom: 10 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              cursor: 'pointer',
              width: 100,
              maxWidth: '30%'
            }}
            onClick={toggleModal}
          >
            <img src={closeOut} alt="Close Out" style={{ width: '100%' }} />
          </div>

          <img src={andembryLogo} alt="Andembry Logo" style={{ width: 200, maxWidth: '50%' }} />
        </div>
        {isiCollapsed && renderMainContent()}
        {renderIsi()}
      </div>
      <div
        style={{
          height: 30,
          padding: '5px 0',
          backgroundColor: '#003C71',
          color: 'white',
          textAlign: 'center'
        }}
      >
        USA-AND-0275-JUN25
      </div>
    </div>
  );
};
export default GaraSplashPage;
